var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -30 512.001 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 209.3687362376,
    x2: 307.1375876594,
    y1: 114.314601267,
    y2: 491.2393247954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 453.1434856904,
    x2: 383.3411905992,
    y1: 274.2121695808,
    y2: 100.3411113412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6299,
    stopColor: "#8393a8",
    stopOpacity: 0.631373
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#445ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#415a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#364d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a3d7c"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0250985624,
    x2: 466.9751214376,
    xlinkHref: "#c",
    y1: 232.3418959034,
    y2: 232.3418959034
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0250985624,
    x2: 466.9751214376,
    xlinkHref: "#c",
    y1: 294.941251429,
    y2: 294.941251429
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0250985624,
    x2: 333.0994121482,
    xlinkHref: "#c",
    y1: 357.5392014638,
    y2: 357.5392014638
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 295.152941 -29.821994)",
    gradientUnits: "userSpaceOnUse",
    x1: 174.9981,
    x2: 190.3743,
    y1: 70.4922,
    y2: 160.8269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#05e5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    stopColor: "#13ddac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    stopColor: "#2ad1a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac9a0"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 320.935792804,
    x2: 450.4157292242,
    y1: 18.180034469,
    y2: 147.6599708892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3262,
    stopColor: "#fe4672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#fb3e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    stopColor: "#f52f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#ee1a51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m495.777344 191.175781h-479.554688c-8.960937 0-16.222656 7.261719-16.222656 16.222657v173.386718c0 8.957032 7.261719 16.21875 16.222656 16.21875 8.089844 0 14.652344 6.5625 14.652344 14.65625v34.332032c0 5.65625 6.84375 8.492187 10.84375 4.488281l46.957031-46.953125c4.175781-4.175782 9.839844-6.523438 15.742188-6.523438h391.363281c8.957031 0 16.21875-7.261718 16.21875-16.222656v-173.386719c0-8.957031-7.261719-16.21875-16.222656-16.21875zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m512 366.417969v-159.019531c0-8.960938-7.261719-16.222657-16.222656-16.222657h-162.914063l168.277344 168.277344c3.730469 2.484375 7.371094 4.8125 10.859375 6.964844zm0 0",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m45.023438 222.695312h421.953124v19.292969h-421.953124zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m466.976562 304.589844h-421.953124v-19.296875h421.953124zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m45.023438 347.890625h288.074218v19.296875h-288.074218zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m16.222656 0h201.6875c8.960938 0 16.222656 7.261719 16.222656 16.222656v77.6875c0 8.960938-7.261718 16.222656-16.222656 16.222656-8.09375 0-14.652344 6.558594-14.652344 14.652344v34.332032c0 5.65625-6.84375 8.492187-10.84375 4.492187l-46.957031-46.957031c-4.175781-4.175782-9.839843-6.523438-15.746093-6.523438h-113.488282c-8.960937 0-16.222656-7.261718-16.222656-16.21875v-77.6875c0-8.960937 7.261719-16.222656 16.222656-16.222656zm0 0",
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m185.625 53.527344c0 8.289062-6.71875 15.007812-15.007812 15.007812-8.289063 0-15.007813-6.71875-15.007813-15.007812 0-8.289063 6.71875-15.007813 15.007813-15.007813 8.289062 0 15.007812 6.71875 15.007812 15.007813zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.074219 53.527344c0 8.289062-6.71875 15.007812-15.007813 15.007812-8.289062 0-15.007812-6.71875-15.007812-15.007812 0-8.289063 6.71875-15.007813 15.007812-15.007813 8.289063 0 15.007813 6.71875 15.007813 15.007813zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.523438 53.527344c0 8.289062-6.71875 15.007812-15.007813 15.007812s-15.011719-6.71875-15.011719-15.007812c0-8.289063 6.722656-15.007813 15.011719-15.007813s15.007813 6.71875 15.007813 15.007813zm0 0"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m449.027344.0820312c-37.816406-1.8437502-69.140625 27.8593748-69.941406 65.0781248-.003907.082032-.03125.082032-.03125 0-.804688-37.21875-32.125-66.921875-69.941407-65.0781248-41.53125 2.0234378-69.097656 42.6445308-61.804687 83.5820308 12.265625 68.851563 97 116.253907 123.714844 129.621094 5.070312 2.539063 11.023437 2.539063 16.09375 0 26.714843-13.367187 111.449218-60.769531 123.714843-129.621094 7.292969-40.9375-20.273437-81.558593-61.804687-83.5820308zm0 0",
    fill: "url(#h)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedback);
export default __webpack_public_path__ + "static/media/icon-feedback.3706f35c151549cb209b2b1e62ab2aad.svg";
export { ForwardRef as ReactComponent };